import React, { useEffect, useRef, useState, useCallback } from 'react'
import { searchCreators, getCreatorsAesthetics } from "../services/CreatorService";
import "../stylesheets/CreatorSearch.css";
import dLogo from "../icons/d-logo.png";
import loadingIcon from "../icons/loading-icon.png";
import { createCampaignCreator, getCampaigns } from "../services/CampaignService";
import {getPopularAesthetics, getTrendingAesthetics} from "../services/AestheticService";
import { getCreatorRatings } from '../services/BusinessService';
import ReactPlayer from 'react-player/lazy'
import Header from './Header';
import {StyleSheet, View, Image, Text, ScrollView, Linking, Pressable} from 'react-native-web';
import Button from './Button';
import IconButton from './IconButton';
import instagramLogo from "../icons/DupeIcons-Instagram.png";
import blueLandscapeIcon from '../icons/blue-landscape-icon.png';
import Modal from 'react-modal';
import countryRegionData from 'country-region-data/data.json';
import CampaignPreview from './CampaignPreview';
import StarRating from './StarRating';
import SettingsNavBar from './SettingsNavBar';
import CreatorModal from './CreatorModal';

const CreatorSearch = () => {
    const [creators, setCreators] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const [settings, setSettings] = useState({});
    const [settingOptions, setSettingOptions] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [addingCreatorId, setAddingCreatorId] = useState("");
    const [page, setPage] = useState(1);
    const [addToCampaignModal, setAddToCampaignModal] = useState(false)
    const [addingCreator, setAddingCreator] = useState({})
    const [totalCreators, setTotalCreators] = useState(0)
    const campaignAddRef = useRef(null);

    // CreatorModal state
    const [creatorModal, setCreatorModal] = useState(false);
    const [selectedCreator, setSelectedCreator] = useState({});
    const [creatorsAesthetics, setCreatorsAesthetics] = useState([]);
    const [selectedAesthetic, setSelectedAesthetic] = useState(null);

    const countryNames = countryRegionData.map(country => country.countryName);

    // const advancedSettingOptions = {
    //     "Cost for one static IG post": [],
    //     "Cost for one IG Reel": [],
    //     "Cost for one TikTok post": [],
    //     "Licensing preference": [],
    //     "Follower count": [],
    //     "Top age of followers": [],
    //     "Top gender of followers": [],
    //     "Top location of followers": [],
    //     "Equipment": []
    // };

    function showSocial(user) {
        setCreators(creators.map(creator => {
            if (creator.id === user.id) {
                return { ...creator, showSocial: true };
            }
            return creator;
        }));
    }

    function showContent(user) {
        setCreators(creators.map(creator => {
            if (creator.id === user.id) {
                return { ...creator, showSocial: false };
            }
            return creator;
        }));
    }

    const openCreatorModal = useCallback(async (creator, aesthetic = null) => {
        setSelectedAesthetic(aesthetic);
        try {
            const [aestheticsResp, ratingsResp] = await Promise.all([
                getCreatorsAesthetics(creator.id),
                getCreatorRatings(creator.id)
            ]);

            if (aestheticsResp?.status === 200 && aestheticsResp?.data) {
                setCreatorsAesthetics(aestheticsResp.data);
            }

            let creatorWithRatings = { ...creator };
            if (ratingsResp?.status === 200 && ratingsResp?.data) {
                creatorWithRatings = {
                    ...creator,
                    avg_quality_rating: ratingsResp.data.avg_quality_rating,
                    avg_responsiveness_rating: ratingsResp.data.avg_responsiveness_rating
                };
            }

            setSelectedCreator(creatorWithRatings);
            setCreatorModal(true);
        } catch (err) {
            console.error('Error fetching creator data:', err);
        }
    }, []);

    const closeModal = useCallback(() => {
        setCreatorModal(false);
        setSelectedAesthetic(null);
        setSelectedCreator({});
        setCreatorsAesthetics([]);
    }, []);

    function kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
    }

    function addCreatorToCampaign(creatorId, campaignId) {
        let req = {};
        req.creatorId = creatorId;
        req.campaignId = campaignId;
        req.stage = 'SHORTLISTED';
        createCampaignCreator(req)
            .then(() => {
                setAddingCreatorId("");
            });
    }

    function updateSetting(event, setting, shouldSearch = true) {
        const newSettings = {
            ...settings,
            [setting]: event.target.value
        };

        setSettings(newSettings);

        // Only trigger search if shouldSearch is true (for onBlur or dropdown changes)
        if (!shouldSearch) {
            return;
        }

        // If Aesthetic is set to "All", treat it as no filter (null)
        if (newSettings.Aesthetic === "All") {
            newSettings.Aesthetic = null;
        }

        setPage(1); // Reset page to 1 when a filter changes
        setIsLoading(true);

        // Create search request with settings and page, excluding Username initially
        const { Username, Countries, ...otherSettings } = newSettings;
        const searchRequest = {
            ...otherSettings,
            page: 1
        };

        // Only include username in search request if it has a valid non-empty value
        if (Username && typeof Username === 'string' && Username.trim() !== "") {
            searchRequest.username = Username.trim();
        }

        // Include Countries array in search request if countries are selected
        if (Countries && Array.isArray(Countries) && Countries.length > 0) {
            searchRequest.Countries = Countries;
        }

        searchCreators(searchRequest)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    const creatorsList = resp.data.creators || [];
                    setTotalCreators(resp.data.totalCreators || 0);
                    setCreators(creatorsList);
                    setIsLoading(false);
                } else {
                    setCreators([]);
                    setTotalCreators(0);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                setIsLoading(false);
                setCreators([]);
                setTotalCreators(0);
            });
    }

    function paginate(page) {
        setCreators([]);
        setPage(page);
        
        // Create search request with current settings and new page, excluding Username initially
        const { Username, Countries, ...otherSettings } = settings;
        let searchRequest = { 
            ...otherSettings,
            page: page 
        };
        
        if (searchRequest.Aesthetic === "All") {
            searchRequest.Aesthetic = null;
        }

        // Only include username in search request if it has a valid non-empty value
        if (Username && typeof Username === 'string' && Username.trim() !== "") {
            searchRequest.username = Username.trim();
        }

        // Include Countries array in search request if countries are selected
        if (Countries && Array.isArray(Countries) && Countries.length > 0) {
            searchRequest.Countries = Countries;
        }
        
        setIsLoading(true);
        searchCreators(searchRequest)
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.creators) {
                    setTotalCreators(resp.data.totalCreators);
                    setCreators(resp.data.creators);
                    setIsLoading(false);
                } else {
                    setCreators([]);
                    setTotalCreators(0);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                setIsLoading(false);
                setCreators([]);
                setTotalCreators(0);
            })
    }

    function closeAddToCampaignModal() {
        setAddToCampaignModal(false);
        setAddingCreator({});
    }

    function openAddToCampaignModal(creator) {
        setAddingCreator(creator);
        setAddToCampaignModal(true);
    }

    useEffect(() => {
        setSettingOptions({
            "Countries": countryNames,
            "Aesthetic": ["travel", "outdoorsy", "city girl", "beachcore"],
            "Compensation": ["All", "Product/Trade", "Paid"],
            "Popularity": ["Popularity", "Posts"],
            "Username": [] // Empty array indicates text input
        });
        const searchReq = {
            "popularity": "LIKES"
        }
        setIsLoading(true);
        searchCreators(searchReq)
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.creators) {
                    setTotalCreators(resp.data.totalCreators);
                    setCreators(resp.data.creators);
                    setIsLoading(false);
                } else {
                    setCreators([]);
                    setTotalCreators(0);
                    setIsLoading(false);
                }
            })
            .catch(() => {
                setIsLoading(false);
                setCreators([]);
                setTotalCreators(0);
            })
        getCampaigns()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    setCampaigns(resp.data);
                }
            })
        getPopularAesthetics()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    let aesthetics = resp.data.map(aesthetic => {
                        return aesthetic.aesthetic
                    })
                    // Sort aesthetics alphabetically
                    aesthetics.sort((a, b) => a.localeCompare(b))
                    setSettingOptions(prevState => {
                        return ({ ...prevState, Aesthetic: ["All"].concat(aesthetics) })
                    })
                    //settingOptions.Aesthetic = "All".concat(resp.data)
                }
            })
        setSettings({
            "Countries": [],
            "Aesthetic": "All",
            "Compensation": "All",
            "Popularity": "Popularity",
            "Username": ""
        })
        const handleClickOutside = (event) => {
            if (campaignAddRef.current && !campaignAddRef.current.contains(event.target)) {
                setAddingCreatorId("");
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };

    }, []);
    return (
        <div className={"creator-search-div"}>
            {isLoading && (
                <img src={loadingIcon} alt="" className={"loading-icon"} />
            )}
            <Header title={"Creator Search"} />
            <SettingsNavBar
                settings={settings}
                settingOptions={settingOptions}
                onSettingChange={updateSetting}
            />
            {creators && creators.map(creator => (
                <View style={styles.creatorPreviewContainer}>
                    <View style={{ justifyContent: "center", gap: 10 }}>
                        <IconButton source={dLogo} onPress={() => showContent(creator)} size={24} accessibilityLabel="Show content" />
                        {creator.instagram && creator.instagram.length > 0 && (
                            <IconButton source={instagramLogo} onPress={() => showSocial(creator)} size={24} accessibilityLabel="Show Instagram" />
                        )}
                    </View>
                    <View style={{ flex: 1 }}>
                        <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                            <Pressable
                                style={({ hovered }) => [
                                    { flexDirection: "row", alignItems: "flex-start", flex: 1, outlineStyle: 'none', borderWidth: 0 },
                                    hovered && styles.creatorCardHovered
                                ]}
                                onPress={() => openCreatorModal(creator)}
                            >
                                <Image style={styles.profileImage}
                                    source={"https://d3p3fw3rutb1if.cloudfront.net/users-preview/" + creator.id} alt={""} />
                                <View style={{ marginLeft: 15, alignContent: "center", flex: 1 }}>
                                    <View style={{ flexDirection: "row", alignItems: "baseline", flexWrap: "wrap" }}>
                                        <Text style={styles.h3}>{creator.first_name} {creator.last_name}</Text>
                                        {creator.country && (
                                            <Text style={[styles.countryText, { marginLeft: 10 }]}>{creator.country}</Text>
                                        )}
                                    </View>
                                    <View style={{ flexDirection: "row" }}>
                                        {creator.aesthetics && creator.aesthetics.map((aesthetic, index) => (
                                            <Pressable
                                                key={index}
                                                style={({ hovered }) => [
                                                    styles.aestheticTag,
                                                    hovered && styles.aestheticTagHovered
                                                ]}
                                                onPress={(e) => {
                                                    e.stopPropagation();
                                                    openCreatorModal(creator, aesthetic);
                                                }}
                                            >
                                                <Text style={styles.aestheticText}>{aesthetic}</Text>
                                            </Pressable>
                                        ))}
                                    </View>
                                    <View style={{ flexDirection: "row", marginTop: 5 }}>
                                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                                            <Image style={{ width: 15, height: 15 }} source={dLogo} alt={""} />
                                            <Text style={styles.followerText}> {kFormatter(creator.follower_count)} Followers</Text>
                                        </View>
                                        {creator.instagram_follower_count > 0 && (
                                            <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 10 }}>
                                                <Image style={{ width: 15, height: 15 }} source={instagramLogo} alt={""} />
                                                <Text style={styles.followerText}> {kFormatter(creator.instagram_follower_count)} Followers</Text>
                                            </View>
                                        )}
                                    </View>
                                    <View style={{ flexDirection: "row", marginTop: 5 }}>
                                        {(creator.avg_quality_rating !== null && creator.avg_responsiveness_rating !== null) && (creator.avg_quality_rating !== undefined && creator.avg_responsiveness_rating !== undefined) ? (
                                            <>
                                                <StarRating rating={creator.avg_responsiveness_rating} label="Responsiveness" />
                                                <StarRating rating={creator.avg_quality_rating} label="Quality" />
                                            </>
                                        ) : (
                                            <Text style={styles.noRatingText}>This creator has not been rated yet.</Text>
                                        )}
                                    </View>
                                </View>
                            </Pressable>
                            <View style={{ alignItems: "flex-end", justifyContent: "flex-start", height: "100%" }}>
                                <Button text="+ Campaign" onPress={() => openAddToCampaignModal(creator)} />
                            </View>
                        </View>
                        {/* <View> */}
                        <ScrollView horizontal={true} scrollEnabled={true} style={{ flexGrow: 0}}>
                            {!creator.showSocial && creator.content && creator.content.map(image => (
                                <div className={"d-inline-block"}>
                                    {image.content_type === "VIDEO" && (
                                        <View style={styles.videoWrapper}>
                                            <ReactPlayer width={"100%"} height={"20vh"} style={{ borderRadius: "50px" }} url={"https://d3p3fw3rutb1if.cloudfront.net/videos/" + image.img_preview_id} muted={true} playing={true} loop={true} />
                                        </View>
                                    )}
                                    {image.content_type !== "VIDEO" && (
                                        // <img className="content-image" alt="" src={"https://d3p3fw3rutb1if.cloudfront.net/photos/" + image.img_preview_id} onClick={() => openContentModal(image.id)} />
                                        <img className={"content-preview-img"}
                                            src={"https://d3p3fw3rutb1if.cloudfront.net/photos/" + image.img_preview_id} alt={""} />
                                    )}
                                </div>
                            ))}
                            {creator.showSocial && creator.instagram && creator.instagram.map(image => (
                                <div className={"d-inline-block"}>
                                    {image.media_url !== "" && image.media_type === "VIDEO" && (
                                        <View style={styles.videoWrapper}>
                                            <ReactPlayer width={"100%"} height={"20vh"} style={{ borderRadius: "50px" }} url={image.media_url} muted={true} playing={true} loop={true} />
                                        </View>
                                    )}
                                    {image.media_url !== "" && image.media_type !== "VIDEO" && (
                                        <img className={"content-preview-img"} src={image.media_url} alt={""} />
                                    )}
                                </div>
                            ))}
                        </ScrollView>
                    </View>
                </View>
            ))}

            <div className={"pagination-div"}>
                <button className={page === 1 ? "selected-page-btn" : "page-btn"} onClick={() => paginate(1)}>1</button>
                {totalCreators > 5 && (
                    <button className={page === 2 ? "selected-page-btn" : "page-btn"} onClick={() => paginate(2)}>2</button>
                )}
                {page > 3 && (
                    <button className={"page-btn"} onClick={() => paginate(page - 1)}>{page - 1}</button>
                )}
                {page > 2 && (
                    <button className={"selected-page-btn"}>{page}</button>
                )}
                {page > 1 && totalCreators > (page*5) && (
                    <button className={"page-btn"} onClick={() => paginate(page + 1)}>{page + 1}</button>
                )}
                {totalCreators > ((page+1)*5) && (
                    <button className={"page-btn"} onClick={() => paginate(page + 2)}>{page + 2}</button>
                )}
                {totalCreators > ((page+2)*5) && (
                    <button className={"page-btn"} onClick={() => paginate(page + 3)}>{page + 3}</button>
                )}
                {totalCreators > ((page+3)*5) && (
                    <button className={"page-btn"} onClick={() => paginate(page + 4)}>{page + 4}</button>
                )}
                {totalCreators > ((page+4)*5) && (
                    <button className={"page-btn"} onClick={() => paginate(Math.ceil(totalCreators/5))}>...{Math.ceil(totalCreators/5)}</button>
                )}
            </div>

            <Modal
                isOpen={addToCampaignModal}
                onRequestClose={closeAddToCampaignModal}
                style={styles.modal}
            >
                <View style={{backgroundColor: 'white', borderRadius: 10, padding: 20, height: '80%'}}>
                    <Text style={[styles.sectionText, {marginBottom: 10, alignSelf: 'center'}]}>Adding {addingCreator.first_name} {addingCreator.last_name} to Campaigns</Text>
                    <ScrollView showsVerticalScrollIndicator={true} ref={campaignAddRef}>
                        {campaigns && campaigns.map(campaign => (
                            <CampaignPreview key={campaign.id} alternateBackground={true} campaign={campaign} creatorId={addingCreator.id}/>
                        ))}
                    </ScrollView>
                </View>
            </Modal>

            <CreatorModal
                isOpen={creatorModal}
                onClose={closeModal}
                selectedCreator={selectedCreator}
                creatorsAesthetics={creatorsAesthetics}
                initialAesthetic={selectedAesthetic}
            />
        </div>

    );
}

const styles = StyleSheet.create({
    videoWrapper: {
        width: '100%',
        height: '20vh',
        borderRadius: 10,
        overflow: 'hidden',
        marginLeft: 2.5,
    },
    profileImage: {
        width: 80,
        height: 80,
        borderRadius: 40,
        borderWidth: 2,
        borderColor: '#e5e7eb',
    },
    h3: {
        color: '#396de0',
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 22,
        fontWeight: 'bold',
        marginBottom: 6,
    },
    followerText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        color: "#6b7280",
        fontWeight: '500',
    },
    aestheticTag: {
        backgroundColor: '#f3f4f6',
        borderRadius: 12,
        paddingVertical: 4,
        paddingHorizontal: 8,
        marginRight: 6,
        marginBottom: 4,
        outlineStyle: 'none',
        borderWidth: 0,
    },
    aestheticText: {
        fontSize: 12,
        color: '#6b7280',
        fontFamily: "'lato', sans-serif",
        fontWeight: '500',
    },
    countryText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        color: "#6b7280",
        // fontWeight: '600',
        // backgroundColor: '#f9fafb',
        paddingVertical: 4,
        // paddingHorizontal: 8,
        // borderRadius: 8,
        // borderWidth: 1,
        // borderColor: '#e5e7eb',
    },
    noRatingText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        color: "#9ca3af",
        fontStyle: 'italic',
        fontWeight: '400',
        marginTop: 5,
    },
    creatorPreviewContainer: {
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        marginLeft: '2.5%',
        marginRight: '2.5%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 8,
        elevation: 3,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
    },
    contentToggle: {
        width: 30,
        height: 30,
    },
    campaignPreviewImage: {
        height: 80,
        width: 80,
        borderRadius: 5,
        margin: 10,
    },
    sectionText: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 30,
        fontWeight: 'bold',
        color: '#396de0',
    },
    modal: {
        overlay: {
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignContent: 'center',
            backgroundColor: 'rgba(57, 109, 224, .5)'
        },
        content: {
            margin: 'auto',
            width: '50%',
            inset: 0,
            background: 'none',
            height: '100%',
            flex: 1,
            border: 'none',
            alignSelf: 'center',
            alignContent: 'center',
        }
    },
    creatorCardHovered: {
        backgroundColor: '#f9fafb',
        transform: [{ scale: 1.01 }],
        transition: 'all 0.2s ease',
        borderRadius: 8,
        outlineStyle: 'none',
    },
    aestheticTagHovered: {
        backgroundColor: '#e5e7eb',
        transform: [{ scale: 1.05 }],
        transition: 'all 0.15s ease',
        cursor: 'pointer',
    },
});



export default CreatorSearch
